import { useEffect } from 'react';

import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';
import { Outlet, useNavigate } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { Header } from '../../components/pages/backoffice/app-header.jsx';
import { Breadcrumbs } from '../../components/pages/backoffice/breadcrumbs.jsx';
import DashboardTablet from '../../components/pages/backoffice/dashboard/tablet.jsx';
import { ProfileDropdown } from '../../components/pages/backoffice/profile-dropdown.jsx';
import { AppSidebar } from '../../components/pages/backoffice/sidebar/app-sidebar.jsx';
import { ThemeSwitch } from '../../components/pages/backoffice/theme-switch.jsx';
import Loading from '../../components/feedback/loading.jsx';
import { SidebarProvider } from '../../components/ui/sidebar.jsx';
import { authState } from '../../services/state/auth-state.jsx';
import { useQueryActiveCampaign } from '../../hooks/queries/use-active-campaign.jsx';
import { cn } from '../../utils/cn.js';
import { CATALYST_USER_ROLES } from '../../utils/constants.js';

export const BackofficeWrapper = () => {
  const { user } = useSnapshot(authState);
  const navigate = useNavigate();
  const defaultOpen = Cookies.get('sidebar:state') !== 'false';

  const queryActiveCampaign = useQueryActiveCampaign();

  useEffect(() => {
    if (!user || user?.details.role === CATALYST_USER_ROLES.customer) {
      navigate('/');
    }
  }, []);

  // TODO: this isn't really viable. When the auth middleware rejects the token the user is reset and this is the screen that is shown to the user
  if (!user) {
    return <Loading />;
  }

  return (
    <div className="flex min-h-[100svh] flex-col items-center justify-center">
      <Helmet>
        <title>{'Backoffice - Plataforma de Campanhas - MAR SHOPPING'}</title>
      </Helmet>

      {!user ||
      user.details.role === CATALYST_USER_ROLES.customer ||
      queryActiveCampaign?.isLoading ? (
        <Loading />
      ) : user.details?.role === CATALYST_USER_ROLES.tablet ? (
        <DashboardTablet />
      ) : (
        <SidebarProvider defaultOpen={defaultOpen}>
          <AppSidebar />
          <div
            id="content"
            className={cn(
              'ml-auto w-full max-w-full',
              'peer-data-[state=collapsed]:w-[calc(100%-var(--sidebar-width-icon)-1rem)]',
              'peer-data-[state=expanded]:w-[calc(100%-var(--sidebar-width))]',
              'transition-[width] duration-200 ease-linear',
              'flex h-svh flex-col',
              'group-data-[scroll-locked=1]/body:h-full',
              'group-data-[scroll-locked=1]/body:has-[main.fixed-main]:h-svh',
            )}
          >
            <Header>
              <div className="ml-auto flex items-center gap-4">
                <ThemeSwitch />
                <ProfileDropdown />
              </div>
            </Header>

            <main
              className={cn(
                'peer-[.header-fixed]/header:mt-16',
                'px-8 py-6',
                'fixed-main flex flex-grow flex-col',
              )}
            >
              {queryActiveCampaign.isLoading ? (
                <Loading />
              ) : queryActiveCampaign.isSuccess ||
                queryActiveCampaign.isError ? (
                <>
                  <Breadcrumbs />
                  <Outlet />
                </>
              ) : null}
            </main>
          </div>
        </SidebarProvider>
      )}
    </div>
  );
};
